import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ncgr-mar-t-24" }
const _hoisted_2 = { class: "ncgr-mar-t-24 ncgr-mar-b-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductSelectForm = _resolveComponent("ProductSelectForm")!
  const _component_ShippingAddressFormCard = _resolveComponent("ShippingAddressFormCard")!
  const _component_PaymentFormCard = _resolveComponent("PaymentFormCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_ProductSelectForm, {
        campaign: _ctx.campaign,
        selections: _ctx.selections,
        onChange: _ctx.handleSelectionsChange
      }, null, 8, ["campaign", "selections", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ShippingAddressFormCard, {
        address: _ctx.shippingAddress,
        isRegistered: _ctx.isAddressRegistered,
        onInput: _ctx.handleAddressInput
      }, null, 8, ["address", "isRegistered", "onInput"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PaymentFormCard, {
        payment: _ctx.payment,
        isRegistered: _ctx.isCreditCardRegistered,
        registeredCreditCard: _ctx.registeredCreditCard,
        isSample: _ctx.campaign.sample,
        onInput: _ctx.handlePaymentInput,
        onEditRegisteredCard: _ctx.handleEditRegisteredCard
      }, null, 8, ["payment", "isRegistered", "registeredCreditCard", "isSample", "onInput", "onEditRegisteredCard"])
    ])
  ]))
}